import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { updateUserBeneficiariesSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormInput, FormChoice, FormButton, FormSubmit } from './common/ValidatedForm';
import { BeneficiaryRelationship, BeneficiaryType } from '../shared/constants/userConstants';
import { Card } from 'antd';
import { useAuth } from '../utils/AuthContext.js';

const BeneficiariesForm = ({ onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { user, api } = useAuth();

  return (
    <ValidatedForm
      key="userBeneficiaries"
      schema={updateUserBeneficiariesSchema}
      initialValues={{ maritalStatus: user.maritalStatus, beneficiaries: user.beneficiaries ?? [] }}
      preValidation={({ iterateList, clearValueIfEmptyString }) => {
        iterateList('beneficiaries', ({ nameFor }) => {
          clearValueIfEmptyString(nameFor('name.middleName'));
        });
      }}
      handleSubmit={api.updateUserBeneficiaries}
      onFinish={onFinish}
    >
      {({ iterateList }) =>
        iterateList('beneficiaries', ({ index, nameFor, remove }) => (
          <Card title={`Beneficiary ${index + 1}`}>
            <FormInput name={nameFor('name.givenName')} type="text" />
            <FormInput name={nameFor('name.middleName')} type="text" />
            <FormInput name={nameFor('name.familyName')} type="text" />
            <FormInput name={nameFor('birthday')} type="date" />
            <FormInput name={nameFor('taxId')} type="text" />
            <FormChoice
              name={nameFor('relationship')}
              options={optionsForEnum(BeneficiaryRelationship)}
              type="select"
            />
            <FormInput name={nameFor('sharePct')} type="text" />
            <FormButton onClick={remove}>{lang('removeBeneficiary')}</FormButton>
          </Card>
        ))
      }
      {({ watch, addToList }) => (
        <FormButton
          onClick={() =>
            addToList('beneficiaries', {
              type: BeneficiaryType.PRIMARY,
              sharePct: watch('beneficiaries').length === 0 ? '100' : '',
            })
          }
        >
          {lang('addBeneficiary')}
        </FormButton>
      )}
      <FormSubmit>{lang('update')}</FormSubmit>
    </ValidatedForm>
  );
};

export default BeneficiariesForm;
